import { assignEnrichmentTools } from "./assignEnrichment";
import { buildAssessments } from "./buildAssessments";
import { createQuestionsTools } from "./createQuestions";
import { pinnedToolsPickerOrder } from "./customizePinnedTools";
import { presentDeliverTool } from "./presentDeliver";
import { solveSupportTool } from "./solveSupport";
import { teachPrepareTools } from "./teachPrepare";
import { yourTools } from "./yourTools";

export const PINNED_TOOLS_MAX = 3;
export const PINNED_TOOLS_STORAGE_KEY = "tema.pinned-tool-ids";

function toPinnableTool(tool) {
  return {
    id: tool.id,
    title: tool.title,
    description: tool.description ?? "",
    iconSrc: tool.iconSrc,
    href: tool.href,
    badge: tool.badge ?? null,
  };
}

export const pinnableToolSections = [
  {
    id: "teach-prepare",
    label: "Teach & Prepare",
    tools: teachPrepareTools.map(toPinnableTool),
  },
  {
    id: "create-questions",
    label: "Create Questions & Sheets",
    tools: createQuestionsTools.map(toPinnableTool),
  },
  {
    id: "build-assessments",
    label: "Build Assessments",
    tools: [
      buildAssessments.primary,
      ...buildAssessments.secondary,
    ].map(toPinnableTool),
  },
  {
    id: "assign-enrichment",
    label: "Assign Enrichment",
    tools: assignEnrichmentTools.map(toPinnableTool),
  },
  {
    id: "present-deliver",
    label: "Present & Deliver",
    tools: [presentDeliverTool].map(toPinnableTool),
  },
  {
    id: "solve-support",
    label: "Doubt Solver",
    tools: [solveSupportTool].map(toPinnableTool),
  },
];

const toolById = new Map(
  pinnableToolSections.flatMap((section) =>
    section.tools.map((tool) => [tool.id, { ...tool, sectionLabel: section.label }]),
  ),
);

export const defaultPinnedToolIds = yourTools.map((tool) => tool.id);

export function getAllPinnableTools() {
  return [...toolById.values()];
}

export function getPinnableToolById(toolId) {
  return toolById.get(toolId) ?? null;
}

export function resolvePinnedTools(toolIds) {
  return toolIds
    .map((id) => getPinnableToolById(id))
    .filter(Boolean);
}

export function getPinnedToolsPickerCatalog() {
  const ordered = pinnedToolsPickerOrder
    .map((id) => getPinnableToolById(id))
    .filter(Boolean);
  const orderedIds = new Set(ordered.map((tool) => tool.id));
  const remainder = getAllPinnableTools().filter((tool) => !orderedIds.has(tool.id));
  return [...ordered, ...remainder];
}

// Re-export picker order for tests
export { pinnedToolsPickerOrder } from "./customizePinnedTools";
